__turbopack_context__.v({
  "panelHeader": "PanelHeader-module__w8iZWW__panelHeader",
});
